import { Record, Map } from "immutable";
import moment from "moment";

const FormsRecord = Record({
  createPagesList: new (Record({
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    fields: new (Record({
      settingName: "",
      settingValue: ""
    }))()
  }))()
});

// We can subclass FormRecord to add custom getters or methods.
export default class Forms extends FormsRecord {}



// WEBPACK FOOTER //
// ./src/common/settingsApi/forms.js